import { ListState } from '../interfaces'

export const resetPage: <C extends string>(state: ListState<C>) => ListState<C> = state => ({
  ...state,
  page: 1,
})
